import React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const NCRTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 580,
    backgroundColor: "#F6F6F6",
    color: "#000000",
    border: "1px solid #D3D3D399",
    padding: "10px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#F6F6F6",
  },
});

export default function NCRAIIcon({ label, aiResponse, handleAIClick }) {
  return (
    <NCRTooltip
      title={
        !aiResponse?.[label] && (
          <div>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
              }}
            >
              Click here to generate AI suggestions
            </Typography>
          </div>
        )
      }
      placement="top-start"
      slotProps={{
        popper: { modifiers: [{ name: "offset", options: { offset: [0, -8] } }] },
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", "&:hover": { cursor: aiResponse?.[label] ? 'default' : 'pointer' }, mx: ['what_went_wrong', 'how_was_issue_identified'].includes(label) ? 3 : 0 }}
        onClick={() => {
          if (!aiResponse?.[label]) {
            handleAIClick(label)
          }
        }}
      >
        <Typography sx={{ color: aiResponse?.[label] ? 'gray' : 'transparent' }} className="ai-suggest-box-label">AI</Typography>
        <img
          src="/images/ai-symbol-icon.svg"
          alt="Icon"
          style={{
            width: 18,
            height: 18,
            filter: aiResponse?.[label] ? "grayscale(100%)" : "none",
            opacity: aiResponse?.[label] ? 0.5 : 1,
          }}
        />
      </Box>
    </NCRTooltip>
  );
}
